<template>
  <case :banner="Banner" :box1="box1" :box2="box2">
    <v-row>
      <v-col cols="12">
        <highlight-container even class="pa-0">
          <p class="text-body" v-html="intro" />
        </highlight-container>
      </v-col>
      <v-col cols="12">
        <highlight-container
          even
          class="pa-0"
          title="Resultados com o selo eureciclo"
        >
          <v-list dense>
            <v-list-item v-for="(result, i) in results" :key="i">
              <v-list-item-icon>
                <v-img
                  :src="require('@/assets/images/materialicons/check.svg')"
                />
              </v-list-item-icon>
              <v-list-item-content
                class="text-body"
                :style="{ color: color }"
                v-html="result"
              />
            </v-list-item>
          </v-list>
        </highlight-container>
      </v-col>
      <v-col cols="12">
        <highlight-container even class="pa-0" title="Os desafios da marca">
          <p
            v-for="(challenge, i) in challenges"
            :key="i"
            class="text-body"
            v-html="challenge"
          />
        </highlight-container>
      </v-col>
      <v-col cols="12">
        <highlight-container even class="pa-0" title="Como o selo contribuiu">
          <p
            v-for="(sp, i) in solvedProblems"
            :key="i"
            class="text-body"
            v-html="sp"
          />
          <div class="py-5">
            <v-img :src="Foto1" contain max-height="350" width="100%" />
          </div>
        </highlight-container>
      </v-col>
      <v-col cols="12">
        <highlight-container
          even
          class="pa-0"
          title="Como a sustentabilidade pode gerar valor para as marcas?"
        >
          <p class="text-body">
            Além da parceria com a eu<b>reciclo</b>, os colaboradores e
            franqueados de Lola Cosmetics começaram a se engajar ainda mais com
            o tema da sustentabilidade e pudemos observar a geração de valor em
            diferentes frentes, sendo algumas delas:
          </p>
          <v-list dense>
            <v-list-item v-for="(s, i) in sustainability1" :key="i">
              <v-list-item-icon>
                <v-img
                  :src="
                    require('@/assets/images/materialicons/circle-medium.svg')
                  "
                  contain
                  width="24"
                />
              </v-list-item-icon>
              <v-list-item-content
                class="text-body"
                :style="{ color: color }"
                v-html="s"
              />
            </v-list-item>
          </v-list>
          <p class="text-body">
            A repercussão foi alta e os clientes da Lola adoraram a preocupação
            com as embalagens. Os comentários foram bastante positivos:
          </p>
          <v-list dense>
            <v-list-item v-for="(s, i) in sustainability2" :key="i">
              <v-list-item-icon>
                <v-img
                  :src="
                    require('@/assets/images/materialicons/circle-medium.svg')
                  "
                  contain
                  width="24"
                />
              </v-list-item-icon>
              <v-list-item-content
                class="text-body"
                :style="{ color: color }"
                v-html="s"
              />
            </v-list-item>
          </v-list>
        </highlight-container>
      </v-col>
      <v-col cols="12">
        <highlight-container
          even
          class="pa-0"
          title="Ações de marketing e engajamento"
        >
          <p class="text-body">
            - Comunicação com consumidores sobre a parceria no Instagram
          </p>
          <p class="text-body">
            - Geração de conteúdo (on e offline) para reafirmar o engajamento da
            marca com suas ações de sustentabilidade
          </p>
          <div class="py-5">
            <v-img :src="Foto2" contain max-height="350" width="100%" />
          </div>
        </highlight-container>
      </v-col>
    </v-row>
  </case>
</template>

<script>
export default {
  name: 'Lola',
  metaInfo: {
    title: 'Case Lola Cosmetics',
  },
  components: {
    Case: () => import('@/components/Case.vue'),
    HighlightContainer: () => import('@/components/HighlightContainer.vue'),
  },
  data() {
    return {
      Banner: require('@/assets/images/cases/lola/banner.jpg'),
      Foto1: require('@/assets/images/cases/lola/foto1.jpg'),
      Foto2: require('@/assets/images/cases/lola/foto2.jpg'),
      box1: {
        title: 'Sobre a Lola Cosmetics',
        text: `Com fórmulas inovadoras, bom humor e empatia, a Lola Cosmetics iniciou em 2011 sua trajetória. A empresa
              afirma que não trabalha apenas com cosméticos, mas sim com respeito, oferecendo uma visão real dos cuidados
              com a saúde capilar e apresentando resultados ao alcance de mulheres comuns. Além disso, a marca inova em
              áreas de tecnologias, comunicação, sustentabilidade e meio ambiente. Todos os produtos Lola Cosmetics são
              veganos, cruelty free e livres de ingredientes que podem apresentar algum malefício à saúde de seus consumidores.`,
      },
      box2: {
        title: 'Selo eureciclo',
        text: `Faça como a &joy, da Enova Foods, e torne-se uma empresa mais sustentável! Com o selo eu<b>reciclo</b>, sua
              empresa compensa o impacto das suas embalagens e adequa-se à legislação, além de incentivar o
              desenvolvimento da cadeia de reciclagem no Brasil e comunicar aos seus consumidores o seu engajamento.`,
        eventLabel: 'case-lola',
      },
      intro: `Veja como a parceria com o selo eu<b>reciclo</b> levou a sustentabilidade também para as embalagens da Lola
              Cosmetics e engajou o consumidor ainda mais com a marca.`,
      results: [
        `Incentivou a coleta, a triagem e a destinação de massas proporcionais aos materiais da embalagem de seus
        produto: 100,0% do Papel, 100,0% do Plástico, 100% do Vidro`,
        'Resíduos compensados pelas cooperativas: 19,34 t do Papel, 66,44 t do Plástico, 12,78 t do Vidro',
        `A empresa beneficiou 33 operadores de reciclagem em 16 estados: BA, CE, DF, ES, GO, MA, MG, PA, PB, PE, PR,
        RJ, RO, RS, SC e SP.`,
      ],
      challenges: [
        '1 - Ter uma ação efetiva para minimizar o impacto do uso de embalagens (plástico, papel e vidro);',
        `2 - Criar uma comunicação fácil com o consumidor, tanto para explicar a ação quanto para engajá-los nas ações de
        sustentabilidade;`,
        `3 - Encontrar uma solução que tivesse rastreabilidade, já que os consumidores são exigentes e querem a comprovação
        de que as ações realmente ajudaram a minimizar o impacto ambiental de sustentabilidade;`,
        '4 - Encontrar uma solução financeiramente viável para a marca.',
      ],
      solvedProblems: [
        `1 - Realizamos a compensação ambiental de 100% das embalagens (reciclagem da mesma massa e material) com
        operadores parceiros;`,
        `2 - A marca passou a utilizar  o selo eu<b>reciclo</b> para ser estampado nas embalagens e mídias sociais da marca,
        com consultoria de marketing para as melhores práticas e estratégias de comunicação com os consumidores;`,
        `3 - Disponibilizamos relatórios de impacto socioambientais, comprovando as compensações e mostrando seu
        impacto social;`,
        '4 - Oferecemos uma solução financeiramente viável para a marca.',
      ],
      sustainability1: [
        `"Por que não fazem como outras empresas e aceitam as embalagens vazias do consumidor e as reutilizam?
        É mais barato do que reciclar! "`,
        `"Vocês podiam fazer algum programa para recolher e reciclar as próprias embalagens né? sempre fico com pena
        de jogar fora."`,
        `Sabe uma opção poderia tornar viável devolvemos os pacotes vazios depois que o produto acabar? Vocês poderiam
        criar pontos de coleta em algumas lojas grandes que são revendedoras dos produtos de vocês, assim íamos na
        loja comprar mais Lola e ao mesmo tempo devolver os potes vazios."`,
      ],
      sustainability2: [
        '"Por isso também uso os produtos da marca."',
        '"Adorei esse Selo eureciclo. Parabéns Lola pelo belo exemplo e consciência"',
        '"Que maravilha que existe todo esse cuidado."”',
      ],
      color: '#59595c !important',
    };
  },
  mounted() {
    this.checkClass();
  },
  methods: {
    checkClass() {
      if (document.querySelector('.new-color')) {
        this.color = '#003036 !important';
      }
    },
  },
};
</script>

<style lang="sass" scoped>
@import "@/styles/util"
@import "@/styles/style"
</style>
